import { useContext } from 'react';
import styled from 'styled-components';
import { colors } from '@karnott/colors';
import { pixelSize, pixelSpacing } from '@karnott/theme';
import { I18nContext } from '../contexts/I18nProvider';
import { Container } from '../ui';

const UnpaidWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100%;
  background-color: ${colors('grey', 50)};
  padding: ${pixelSpacing('large')};
`;

const MessageContainer = styled(Container)`
  background-color: ${colors('white')};
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  max-width: 600px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: auto;
  padding: ${pixelSpacing('large')};
`;

const Title = styled.h1`
  color: ${colors('black', 400)};
  font-size: ${pixelSize('xLarge')};
  font-weight: 600;
  margin-bottom: ${pixelSpacing('large')};
  margin-top: ${pixelSpacing('medium')};
`;

const Message = styled.p`
  color: ${colors('black', 400)};
  font-size: ${pixelSize('large')};
  line-height: 1.6;
  margin-bottom: ${pixelSpacing('small')};
  white-space: pre-line;
`;

const ContactInfo = styled.p`
  color: ${colors('black', 400)};
  line-height: 1.6;
  font-size: ${pixelSize('large')};
  margin-bottom: ${pixelSpacing('medium')};
`;

const ThankYou = styled.p`
  color: ${colors('black', 400)};
  font-size: ${pixelSize('large')};
`;

function UnpaidContainer() {
  const { t } = useContext(I18nContext);

  return (
    <UnpaidWrapper>
      <MessageContainer>
        <Title>{t('Unpaid.title')}</Title>
        <Message>{t('Unpaid.message')}</Message>
        <ContactInfo>{t('Unpaid.contact')}</ContactInfo>
        <ThankYou>{t('Unpaid.thankYou')}</ThankYou>
      </MessageContainer>
    </UnpaidWrapper>
  );
}

export default UnpaidContainer;
